import FacilitiesSelect from './FacilitiesSelect';

export default FacilitiesSelect;

export { default as Dining } from './Dining';
export { default as Clubs } from './Clubs';
export { default as Parking } from './Parking';
export { default as Pets } from './Pets';
export { default as Pool } from './Pool';
export { default as Family } from './Family';
export { default as Transport } from './Transport';
export { default as Wellness } from './Wellness';
export { default as Activities } from './Activities';
export { default as Business } from './Business';
export { default as Sustainability } from './Sustainability';
